import { ExportCategories } from "PFApp/booking/types/export_booking";
import { Collection } from "PFTypes";

import exportData from "./mock.json";

const RECORDS_COUNT = 3;

export const getMockedExportData = (): Collection<ExportCategories[]> => ({
  ...exportData,
  entries: Array(RECORDS_COUNT).fill(exportData.entries)
});
